import { useQuery } from "@apollo/client";
import { ActivityByIdDocument } from "../../../../../../../../__generated__/graphql";

export default function useActivityById(activityId?: string | null) {
  const { data, loading, error, refetch } = useQuery(ActivityByIdDocument, {
    variables: { activityId: activityId ?? "" },
    skip: !activityId,
  });

  return { data, loading, error, refetch };
}
